import React, { Suspense } from 'react'
import Card from 'src/components/Card'
import Body from './Body'
import Loading from './Loading'
import { Breadcrumb, BreadcrumbItem, Card as BSCard } from 'reactstrap'

const List: React.FC = (props) => {
  return (
    <>
      <BSCard className='mb-2 p-2 ps-3 w-auto small text-body-secondary'>
        <Breadcrumb className='mb-0' listClassName='mb-0'>
          <BreadcrumbItem>
            Lookups
          </BreadcrumbItem>
        </Breadcrumb>
      </BSCard>
      <Card title='Lookups'>
        <Suspense fallback={<Loading />}>
          <Body />
        </Suspense>
      </Card>
    </>
  )
}

export default List
